import RulingsController from './RulingsController';

export { RulingsController };
